<template>
  <v-card v-if="showDialog" class="floating-card" elevation="12">
    <div class="d-flex flex-column justify-center card-layout">
      <div class="md-body">{{ message }}</div>
      <v-spacer />
      <v-btn @click="clickButton" color="primary" class="text-white button">{{
        buttonText
      }}</v-btn>
    </div>
  </v-card>
</template>

<script>
// import rules from "@/mixins/rules";
// import helpers from "@/mixins/helpers";
// import moment from "moment";
import _ from "lodash";
// import { mapGetters } from "vuex";

export default {
  props: {
    showDialog: Boolean,
    buttonText: String,
    routeTo: String,
    message: String,
  },

  data() {
    return {};
  },
  mounted() {},
  methods: {
    clickButton() {
      if (this.routeTo) {
        this.$router.push(this.routeTo);
      } else {
        this.$emit("click");
      }
    },
  },
};
</script>
<style scope>
.floating-card {
  position: fixed !important;
  bottom: 0px;
  right: 0px;
  width: 350px;
  margin: 50px;
  border-radius: 8px !important;
  padding: 25px;
}

.card-layout {
  height: 100%;
}

.button {
  margin: 0px;
}
</style>
